import { createContext, useContext } from 'react';

/**
 * EL CONTEXTO DE DESHACER, separado de su proveedor.
 *
 * Vive aparte porque `react-refresh/only-export-components` avisa cuando un
 * archivo exporta un componente y además otra cosa, y el lint del panel corre
 * con `--max-warnings 0`. Ya pasó lo mismo con los iconos del menú: dejar el
 * aviso tiene la build en rojo, y una build en rojo permanente enseña a
 * ignorar el rojo.
 */

export interface Ofrecimiento {
  texto: string;
  deshacer: () => void | Promise<void>;
}

export interface ContextoDeshacer {
  /** Muestra la barra con su acción de revertir. */
  ofrecerDeshacer: (o: Ofrecimiento) => void;
}

export const CtxDeshacer = createContext<ContextoDeshacer | null>(null);

/**
 * Fuera del proveedor devuelve una función que no hace nada, en vez de
 * reventar: una pantalla suelta en una prueba no debería fallar por no tener
 * la barra puesta.
 */
export function useDeshacer(): ContextoDeshacer {
  return useContext(CtxDeshacer) ?? { ofrecerDeshacer: () => {} };
}
